import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
    const { user, login, error } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const nav = useNavigate();

    if (user && user.email) return <Navigate to="/admin/dashboard" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        const ok = await login(email.trim(), password.trim());
        setBusy(false);
        if (ok) nav("/admin/dashboard");
    };

    return (
        <div data-testid="admin-login-page" className="min-h-[80vh] grid grid-cols-12">
            <div className="hidden md:flex col-span-6 bg-[#333] text-[#FFFFFF] p-16 items-end">
                <div>
                    <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#FFFFFF]/60">admin console</div>
                    <div className="mt-6 font-heading font-black text-6xl uppercase tracking-tighter leading-[0.9]">
                        katu<span className="text-[#5D3FD3]">.</span>
                        <br />
                        control room.
                    </div>
                    <p className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-[#FFFFFF]/60 max-w-sm">
                        manage the roster, the agenda and the objects.
                    </p>
                </div>
            </div>
            <div className="col-span-12 md:col-span-6 p-8 md:p-16 flex items-center">
                <form onSubmit={submit} className="w-full max-w-md">
                    <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#555]">sign in</div>
                    <h1 className="mt-3 font-heading font-black text-4xl md:text-5xl uppercase tracking-tighter">access.</h1>

                    <label className="block font-mono text-[10px] uppercase tracking-[0.2em] mt-8 mb-2">email</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        data-testid="login-email"
                        className="w-full bg-transparent focus:border-[#5D3FD3] outline-none font-mono text-sm py-2"
                    />

                    <label className="block font-mono text-[10px] uppercase tracking-[0.2em] mt-6 mb-2">password</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        data-testid="login-password"
                        className="w-full bg-transparent focus:border-[#5D3FD3] outline-none font-mono text-sm py-2"
                    />

                    {error && (
                        <div data-testid="login-error" className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-[#5D3FD3]">
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={busy}
                        data-testid="login-submit"
                        className="mt-8 w-full bg-[#333] text-[#FFFFFF] hover:bg-[#5D3FD3] hover:text-[#333] transition-colors duration-300 rounded-none px-6 py-3 font-mono text-xs uppercase tracking-widest disabled:opacity-60"
                    >
                        {busy ? "signing in…" : "enter"}
                    </button>
                </form>
            </div>
        </div>
    );
}
